const VAT_FREE_SUFFIX = "-VAT-FREE";

const SessionStorageKey = Object.freeze({
    VAT_NAME: "vatExemptionName",
    VAT_REASON: "vatExemptionReason",
    VAT_CHECKBOX: "vatExemptionCheckbox",
});

/**
 * @returns {Promise<boolean>}
 */
async function cartContainsVatFree() {
    const data = await sendRequest("cart").then(r => r.json());

    for (const {sku} of data.items) {
        if (sku.endsWith(VAT_FREE_SUFFIX)) return true;
    }
    return false;
}

/**
 * Swaps products with their VAT-free version.
 * @param include_vat Whether to swap to VAT or VAT-free products.
 * @returns {Promise<void>}
 */
async function swapVat(include_vat) {
    const data = await sendRequest("cart").then(r => r.json());

    /**
     * @type {Promise<null | {id: number, quantity: number, vat_free_id: number}>[]}
     */
    const promises = data.items.map(async ({url, quantity, sku, id}) => {
        const qi = url.indexOf("?");
        const path = qi === -1 ? url : url.substring(0, qi);
       // console.log(path);

        /** @type {Response} */
        let response;
        /** @type {string} */
        let vat_sku;

        if (include_vat) {
            // VAT
            if (!sku.endsWith(VAT_FREE_SUFFIX)) return null; // not a VAT-Free product
            vat_sku = sku.substring(0, sku.length - VAT_FREE_SUFFIX.length);
            response = await fetch(path.replace(/-vat-free/i, "") + ".js");
        } else {
            // VAT-free
            // saveExemptionCheckboxToSessionStorage();
            if (sku.endsWith(VAT_FREE_SUFFIX)) return null; // already VAT-Free product
            response = await fetch(path + "-vat-free.js");
            vat_sku = sku + VAT_FREE_SUFFIX;
        }
        if (!response.ok) return null; // no VAT(-free) product

        const data = await response.json();
        // Find VAT(-free) product variant
        const vat_free_diaper = data.variants.find(it => it.sku === vat_sku);
        if (!vat_free_diaper) return null; // no VAT(-free) product variant
        return include_vat ? {
            id: vat_free_diaper.id,
            quantity,
            vat_free_id: id,
        } : {
            id,
            quantity,
            vat_free_id: vat_free_diaper.id,
        };
    });

    const results = (await Promise.all(promises)).filter(p => p !== null);

    if (results.length === 0) return;

    let products_to_add, products_to_remove;
    if (include_vat) {
        // adds VAT product
        products_to_add = Object.fromEntries(results.map(({id, quantity}) => [id, quantity]));
        // removes VAT-free product
        products_to_remove = Object.fromEntries(results.map(({vat_free_id: id}) => [id, 0]));

    } else {
        // adds VAT-free product
        products_to_add = Object.fromEntries(results.map(({vat_free_id: id, quantity}) => [id, quantity]));
        // removes VAT product
        products_to_remove = Object.fromEntries(results.map(({id}) => [id, 0]));

    }
    //console.table(results);
    //console.table(products_to_remove);

    await updateProducts({...products_to_remove, ...products_to_add});
}

async function swapVatonload(include_vat) {
    const data = await sendRequest("cart").then(r => r.json());
    const diapers = data.items.filter(it => it.product_type === "Diapers");

    /**
     * @type {Promise<null | {id: number, quantity: number, vat_free_id: number}>[]}
     */
    const promises = diapers.map(async ({url, quantity, sku, id}) => {
        const qi = url.indexOf("?");
        const path = qi === -1 ? url : url.substring(0, qi);
        //console.log(path);

        /** @type {Response} */
        let response;
        /** @type {string} */
        let vat_sku;

        if (include_vat) {
            // VAT
            if (!sku.endsWith(VAT_FREE_SUFFIX)) return null; // not a VAT-Free product
            vat_sku = sku.substring(0, sku.length - VAT_FREE_SUFFIX.length);
            response = await fetch(path.replace(/-vat-free/i, "") + ".js");
        } else {
            // VAT-free
            // saveExemptionCheckboxToSessionStorage();
            if (sku.endsWith(VAT_FREE_SUFFIX)) return null; // already VAT-Free product
            response = await fetch(path + "-vat-free.js");
            vat_sku = sku + VAT_FREE_SUFFIX;
        }
        if (!response.ok) return null; // no VAT(-free) product

        const data = await response.json();
        // Find VAT(-free) product variant
        const vat_free_diaper = data.variants.find(it => it.sku === vat_sku);
        if (!vat_free_diaper) return null; // no VAT(-free) product variant
        return include_vat ? {
            id: vat_free_diaper.id,
            quantity,
            vat_free_id: id,
        } : {
            id,
            quantity,
            vat_free_id: vat_free_diaper.id,
        };
    });

    const results = (await Promise.all(promises)).filter(p => p !== null);

    if (results.length === 0) return;

    let products_to_add, products_to_remove;
    if (include_vat) {
        // adds VAT product
        products_to_add = Object.fromEntries(results.map(({id, quantity}) => [id, quantity]));
        // removes VAT-free product
        products_to_remove = Object.fromEntries(results.map(({vat_free_id: id}) => [id, 0]));

    } else {
        // adds VAT-free product
        products_to_add = Object.fromEntries(results.map(({vat_free_id: id, quantity}) => [id, quantity]));
        // removes VAT product
        products_to_remove = Object.fromEntries(results.map(({id}) => [id, 0]));

    }
   // console.table(results);
    //console.table(products_to_remove);

    await updateProducts({...products_to_remove, ...products_to_add});
}


/**
 * Sends a request to the Shopify root route.
 * @param endpoint {string} The API endpoint to use.
 * @param method {"GET" | "POST" | "DELETE"} The HTTP method to use.
 * @param body {object?} JSON request body.
 * @param request {Request?} Other fetch request parameters.
 * @returns {Promise<Response>}
 * @throws when the request fails.
 */
async function sendRequest(endpoint, method = "GET", body = null, request = {}) {
    const response = await fetch(
        `${window.Shopify.routes.root}${endpoint}.js`,
        {
            ...request,
            method,
            ...(body ? {
                body: JSON.stringify(body),
                headers: {'Content-Type': 'application/json'}
            } : {}),
        }
    );
    const {status} = response;
    if (status >= 500) {
        throw new Error(response.statusText);
    }
    if (status >= 400) {
        const json = await response.json();
        throw new Error(`${json.message}: ${json.description}`);
    }
    return response;
}

/**
 * Adds a product to the cart.
 * @param products {object[]} Products to add.
 * @param products.id {number} Id of the product.
 * @param products.quantity {number} Quantity of the product.
 * @returns {Promise<void>}
 */
async function addProducts(products) {
    await sendRequest("cart/add", "POST", {
        items: products
    });
}

/**
 * Changes a product's quantity in the cart.
 * @param quantities {Record<number, number>} Map from product to quantity.
 * @returns {Promise<void>}
 */
async function updateProducts(quantities) {
    await sendRequest("cart/update", "POST", {
        updates: quantities
    });
}

{
    const oldSet = sessionStorage.setItem;
    sessionStorage.setItem = function setItemMock(name, value) {
       // console.debug(`sessionStorage.setItem("${name}", "${value}")`);
       // console.trace();
        oldSet.call(this, name, value);
    }

    const oldGet = sessionStorage.getItem;
    sessionStorage.getItem = function getItemMock(name) {
        const value = oldGet.call(this, name);
        //console.debug(`sessionStorage.getItem("${name}") → ${JSON.stringify(value)}`);
        //console.trace();
        return value;
    }
}

function saveVatExemptionNameToSessionStorage() {
    const vatExemptionName = document.getElementById("vat_exemption_name").value;
    sessionStorage.setItem(SessionStorageKey.VAT_NAME, vatExemptionName);
}

function saveVatExemptionReasonToSessionStorage() {
    const vatExemptionReason = document.getElementById("vat_exemption_reason").value;
    sessionStorage.setItem(SessionStorageKey.VAT_REASON, vatExemptionReason);
}

function saveVatExemptionCheckboxToSessionStorage() {
    const value = document.getElementById("vatExemptionCheckbox").checked;
    sessionStorage.setItem(SessionStorageKey.VAT_CHECKBOX, value);
}

function fillVatExemptionNameFromSessionStorage(targetInputId) {
    if (!targetInputId) throw new TypeError("Missing 'targetInputId'");

    const vatExemptionName = sessionStorage.getItem(SessionStorageKey.VAT_NAME);
    if (vatExemptionName === null) return;
    document.getElementById(targetInputId).value = vatExemptionName;
    //console.log("load name");
   // console.log(vatExemptionName);
}

function fillVatExemptionReasonFromSessionStorage(targetInputId) {
    if (!targetInputId) throw new TypeError("Missing 'targetInputId'");

    const vatExemptionReason = sessionStorage.getItem(SessionStorageKey.VAT_REASON);
    if (vatExemptionReason === null) return;
    document.getElementById(targetInputId).value = vatExemptionReason;
}

function fillVatExemptionCheckboxFromSessionStorage(targetInputId) {
    if (!targetInputId) throw new TypeError("Missing 'targetInputId'");

    const vatExemptionCheckbox = sessionStorage.getItem(SessionStorageKey.VAT_CHECKBOX);
    if (vatExemptionCheckbox === null) return;
    document.getElementById(targetInputId).checked = vatExemptionCheckbox === "true";
}

/**
 * @param {number} ms Milliseconds to sleep for
 * @returns {Promise<void>}
 */
function sleep(ms) {
    return new Promise((resolve) => setTimeout(resolve, ms));
}
